import { ref } from "vue";
import { clear_token, get_token, get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import ReportCommentModal from "@/components/ReportCommentModal/ReportCommentModal.vue";
import AllPortals from "@/components/GetPortals/PortalsComponent.vue"
import AllTopics from "@/components/GetTopics/TopicsComponent.vue"
import FloatingButton from "@/components/FloatingButton/FloatingButtonComponent.vue"
import Swal from 'sweetalert2';
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue"
import Loader from "@/components/Loader/LoaderView";
import PortalMembers from "@/components/PortalMembers/PortalMembers.vue";
import PortalRequest from "@/components/GetPortalRequest/PortalRequestView.vue"
import DocumentApproval from "@/components/DocumentApproval/DocumentApproval.vue";
import DocumentWarehouse from "@/components/DocumentWarehouse/DocumentWarehouse.vue";
import SprintAgentModal from "@/components/SprintAgent/SprintAgent.vue";
import SubPortalView from "@/components/SubPortal/SubPortalView.vue";
import SurveyView from "@/components/SurveysAndPolls/Survey.vue";
import CreateFeed from "@/components/CreateFeed/CreateFeed.vue";
import AllGroups from "@/components/GetGroups/GroupsComponent.vue";
import PortalEvents from "@/components/PortalEvents/PortalEventsView.vue";
import PortalSide from "@/components/PortalSidebar/PortalSide.vue";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import Comments from '@/components/Comments/Comments.vue';
import PortalRoles from "@/components/PortalRoles/PortalRoles.vue";
import axios from "axios";
const GLOBAL_URL = process.env.VUE_APP_BACKEND_API_URL;

import { nextTick } from 'vue';
import { client_domain } from "@/main.js";
import { open_preview as open_file_preview } from "@/utils/file_preview";
import { export_personal_profile_form_table_csv } from "@/utils/csv_styling";
import { handle_event_list_realtime } from "@/services/eventRealtimeHandlers";
import { handle_report_realtime } from "@/services/realtime_report_helper";
/* global bootstrap */


export default {
  components: {
    SprintAgentModal,
    ReportCommentModal,
    HomeNavBar,
    AllPortals,
    AllTopics,
    FloatingButton,
    StickyNav,
    Loader,
    PortalMembers,
    PortalRequest,
    DocumentApproval,
    DocumentWarehouse,
    SubPortalView,
    SurveyView,
    CreateFeed,
    AllGroups,
    PortalEvents,
    PortalSide,
    InactivityModal,
    Comments,
    PortalRoles
  },
  setup() {
    const activeTab = ref("your_feed"); // Default active tab
    return { activeTab };

  },
  created(){
    this.filterReports();
    this.fetch_portal_boards();

    if (this.$route.query.topic_id) {
       this.activeTab = "voice";
    }
  },
  mounted() {
    nextTick(() => {
        if (this.$refs.scrollContainer) {
          this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll);
        }
      });

    this.token_exists = get_token();
    this.setupTextareaAutoResize();
    this.user_id = parseInt(this.get_user_id(), 10);
    this.user_details = get_user_details();

    this.fetch_Portal_admin();
    // this.fecthPortalData();
    this.fetchPortalMembers();
    this.get_permissions_types();
    const permission_modal = $('#manage_portal_permissions_modal')
    permission_modal.on('show.bs.modal', () => {
      this.get_permissions_types();
    })


    if (client_domain.includes('workbook') || client_domain.includes('workstreams')) {
      this.workbook_domain = true;
    }
    if (client_domain.includes('cbo')) {
      this.cbo_domain = true;
    }
     if (client_domain.includes('chiefluthuli')) {
      this.school_domain = true;
    }


    if(client_domain.includes('soulcity') ||  client_domain.includes('nsp') ||  client_domain.includes('aicreads')) {
      this.soulcity_domain = true;
    }

  if (client_domain.includes('soulcity') || client_domain.includes('dwypd') || client_domain.includes('nsp')) {
        this.dwypd_domain = true;
      }

    this._realtime_event_handler = (evt) => this.handle_realtime_event(evt);
    window.addEventListener("realtime:event", this._realtime_event_handler);

    this._realtime_report_handler = (realtime_event) =>
      this.handle_realtime_report(realtime_event);
    window.addEventListener("realtime:report", this._realtime_report_handler);
  },
  beforeUnmount() {
    if (this._realtime_event_handler) {
      window.removeEventListener("realtime:event", this._realtime_event_handler);
      this._realtime_event_handler = null;
    }
    if (this._realtime_report_handler) {
      window.removeEventListener("realtime:report", this._realtime_report_handler);
      this._realtime_report_handler = null;
    }
    this.destroy_personal_profile_form_datatables();
  },
  computed: {
    paginatedReports() {
  return this.reports.slice(0, 20); // show 20 at a time
},
    hasMoreReports() {
      return this.reports.length > this.currentPage * this.reportsPerPage;
    },
    isMaster() {
      return this.portal_profile?.master_portal?.is_master || false;
    },
    filteredUsers() {
    let members = this.members.filter(user => user.id !== this.user_id);

    if (!this.searchQuery) return members;

    const query = this.searchQuery.toLowerCase();

    return members.filter(user => {
      const first = user.first_name ? user.first_name.toLowerCase() : "";
      const last = user.last_name ? user.last_name.toLowerCase() : "";
      return first.includes(query) || last.includes(query);
    });
  }

  },
  props: ['topic_id'],

  data() {
    return ({
      modal_likes: [],
      linkPreview: null,
      portals: [],
      selectedPortal: null,
      reportToForward: null,
      temporaryPost: null,
      reports: [],
      events: [],
      topics: [],
      document_approvals: [],
      topic: '',
      description: '',
      upload_media_hub: '',
      loading: true,
      topic_id: '',
      exchange_hubs: {},
      isLoading: false,
      portal_profile:{},
      token_exists: false,
      user_id: null,
      user_details: {
        "user_role": '',
        "first_name": '',
        "last_name": '',
      },
      report_data: {},
      sprint_data:{},
      topic_name: '',
      isSubmitting: false,
      errors:{
        edit_voice_name:'',
        editFileError:null,
        editAudioError:null,
        editFileName:null,
      },
      portalCount :0,
      currentPage: 1,
      reportsPerPage: 20,
      comment_modal_visible: false,
      agent_modal:false,
      expandedReports: [],
      feed_toggle: true,
      voice_toggle: false,
      edit_name:'',
      edit_description:'',
      edit_report_name: '',
      edit_report_id: null,
      edit_report_description: '',
      edit_documents:[],
      visible_domain: false,
      isRecording: false,
      audio_file: null,
      mediaRecorder: null,
      recordedChunks: [],
      audio_file_name: '',
      upload_media: null,
      fileError : '',
      audioError: '',
      editFileName:'',
      pdf_file: null,
      pdf_file_url: null,
      portal_admin:false,
      workbook_domain:false,
      cbo_domain:false,
      boards:[],
      activeProfile:[],
      permission_types: [],
      permission_map: {},
      portal_permissions: [],
      filtered_portal_permissions: [],
      activeCommentReportId: null,
      is_report_loading: false,
      likedReports: JSON.parse(localStorage.getItem("likedReports") || "{}"),
      members: [],
      personal_profile_forms_users: [],
      loading_personal_profile_forms: false,
      personal_profile_forms_loaded: false,
      personal_profile_forms_portal_id: null,
      personal_profile_forms_request_key: 0,
    searchQuery: "",
    showSuggestions: false,
      soulcity_domain: false,
      dwypd_domain: false,
    page: 1,
    page_size: 5,
    portal_count: 0, // count of members
    current_portal_permissions: {
      create: false,
      edit: false,
      upload: false,
      download: false,
      delete: false
    },
    preloadedReports: [],
    maxLength : 150,
    editingBoard: null,
    board_name: null,
    isEditing: false,
    comments_off: true,
    loading_members:false,
    school_domain:false,
      loading_preview: false,

    });
  },
  watch:{
    '$route.params.portal_id'(newPortalId, oldPortalId) {
      this.fetch_portal_boards();
      this.filterReports();
      // this.fecthPortalData();

      this.reset_personal_profile_forms_state();
      this.fetchPortalMembers();

      if (newPortalId !== oldPortalId && this.activeTab === 'personal_profiles') {
        this.fetch_personal_profile_forms(true);
      }
    },
    activeTab(newTab) {
      if (newTab === 'personal_profiles') {
        const currentPortalId = String(this.$route.params.portal_id || '');
        this.fetch_personal_profile_forms(this.personal_profile_forms_portal_id !== currentPortalId);
      }
    }
    },

  methods: {
    handle_realtime_event(realtime_event) {
      handle_event_list_realtime(this, realtime_event, { list_names: ["events"] });
    },
    handle_realtime_report(realtime_event) {
      handle_report_realtime(this, realtime_event);
    },
    can_manage_portal() {
      const is_private = this.$route.params.is_public === "false";

      const is_owner =
          String(this.portal_profile?.creater_id) ===
          String(this.user_details?.user_id);

      const is_admin =
          this.user_details?.user_role === "admin" ||
          this.portal_admin;

      return is_private && (is_admin || is_owner);
  },
    hide_dropdown_menu(event) {
      const menu = event?.currentTarget;
      const dropdown = menu?.closest(".dropdown, .dropstart, .dropend, .dropup");
      const toggle = dropdown?.querySelector('[data-bs-toggle="dropdown"]');

      if (toggle && window.bootstrap?.Dropdown) {
        window.bootstrap.Dropdown.getOrCreateInstance(toggle).hide();
        return;
      }

      menu?.classList.remove("show");
      toggle?.setAttribute("aria-expanded", "false");
    },
     get_personal_profile_picture(profileFiles) {
      if (!Array.isArray(profileFiles)) {
        return require('@/assets/images/user.png');
      }

      const profilePic = profileFiles.find(
        file => file.profile_file_type === 'profile_picture'
      );

      return profilePic?.file?.url;
    },


  get_profile_picture(item) {
    const base = item.base_profile || item;
    // PERSONAL PROFILE
    if (base.profile_type === 'personal') {
      const pic = base.user.profile.profile_files.find(f => f.profile_file_type === 'profile_picture');
      return pic?.file?.url || null;
    }

    // BUSINESS PROFILE
    if (base.profile_type === 'business') {
      const logo = base.company.base_profile.profile_files[0]?.file;
      return logo?.file_url || logo?.url || null;
    }

    return null;
  },
  toggle_comment(report_id) {
    // If the same report is clicked, close it
    if (this.activeCommentReportId === report_id) {
      this.activeCommentReportId = null;
    } else {
      // Otherwise open the clicked report
      this.activeCommentReportId = report_id;
    }
  },
    onActiveProfileLoaded(profile) {
    this.activeProfile=profile},

     openCreateBoardModal() {
    const offcanvasEl = document.getElementById('boards_offcanvas')
    const offcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl)

    if (offcanvas) {
      offcanvas.hide()
    }

    setTimeout(() => {
      const modal = new bootstrap.Modal(
        document.getElementById('create_board_modal')
      )
      modal.show()
    }, 300) // delay is CRITICAL on mobile
  },

    handleScroll() {
    const container = this.$refs.scrollContainer;
    if (!container) return;

    const scrollBottom = container.scrollTop + container.clientHeight;
    if (scrollBottom >= container.scrollHeight - 50) { // near bottom
      this.filterReports();
    }
  },

fetchReportPreview(report) {

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/fetch_url_meta/`,
    type: 'POST',
    data: { url: report.report_link },
    headers: { Authorization: `Token ${get_token()}` },
    success: (data) => { report.linkPreview = data; },
  });
},
    fetchPortalMembers() {

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
      method: "GET",
      data: { portal_id: this.$route.params.portal_id },
      headers: {
        "Authorization": `Token ${this.getToken()}`,
        "Content-Type": "application/json"
      },
      success: (response) => {
        if (response.status === "success") {
          this.members = response.data.members
            .filter(m => m.user && m.user.first_name && m.user.last_name)
            .map(m => ({
              id: m.user.id,
              first_name: m.user.first_name,
              last_name: m.user.last_name,
              full_name: `${m.user.first_name} ${m.user.last_name}`
            }));
          this.portal_count = this.members.length;


        }
      },
      error: (xhr) => console.error("Error fetching portal members:", xhr)
    });
  },
    fetch_personal_profile_forms(force_reload = false) {
      const portalId = String(this.$route.params.portal_id || '');

      if (this.loading_personal_profile_forms && !force_reload) {
        return;
      }

      if (this.personal_profile_forms_loaded && this.personal_profile_forms_portal_id === portalId && !force_reload) {
        this.$nextTick(() => {
          this.init_personal_profile_form_datatables();
        });
        return;
      }

      const requestKey = this.personal_profile_forms_request_key + 1;
      this.personal_profile_forms_request_key = requestKey;
      this.personal_profile_forms_portal_id = portalId;
      this.loading_personal_profile_forms = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_personal_profile_forms/`,
        method: "POST",
        headers: {
          "Authorization": `Token ${this.getToken()}`,
          "Content-Type": "application/json"
        },
        data: JSON.stringify({ portal_id: portalId }),
        success: (response) => {
          if (requestKey !== this.personal_profile_forms_request_key || portalId !== String(this.$route.params.portal_id || '')) {
            return;
          }

          if (response.status === "success") {
            this.personal_profile_forms_users = Array.isArray(response.data) ? response.data : [];
            this.personal_profile_forms_loaded = true;
          }
        },
        error: (xhr) => {
          if (requestKey !== this.personal_profile_forms_request_key) {
            return;
          }

          console.error("Error fetching personal profile forms:", xhr);
        },
        complete: () => {
          if (requestKey === this.personal_profile_forms_request_key) {
            this.loading_personal_profile_forms = false;
            this.$nextTick(() => {
              this.init_personal_profile_form_datatables();
            });
          }
        }
      });
    },

    reset_personal_profile_forms_state() {
      this.destroy_personal_profile_form_datatables();
      this.personal_profile_forms_request_key += 1;
      this.personal_profile_forms_users = [];
      this.personal_profile_forms_loaded = false;
      this.personal_profile_forms_portal_id = null;
      this.loading_personal_profile_forms = false;
    },

    open_personal_profile_forms_tab() {
      this.activeTab = 'personal_profiles';
      this.fetch_personal_profile_forms();

      this.$nextTick(() => {
        const personalProfilesTab = document.getElementById('tab-personal-profiles');
        if (personalProfilesTab) {
          personalProfilesTab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    },

    init_personal_profile_form_datatables() {
      if (!$.fn.DataTable) {
        return;
      }

      $('.personal-profile-form-table').each(function () {
        const table = $(this);

        if ($.fn.DataTable.isDataTable(this)) {
          table.DataTable().clear().destroy();
        }

        table.DataTable({
          paging: true,
          searching: true,
          ordering: true,
          info: true,
          lengthChange: true,
          pageLength: 10,
          lengthMenu: [10, 25, 50, 100],
          scrollX: true,
          autoWidth: false,
          layout: {
            topStart: 'pageLength',
            topEnd: 'search',
            bottomStart: 'info',
            bottomEnd: 'paging'
          },
          language: {
            paginate: {
              previous: "Previous",
              next: "Next"
            },
            info: "Showing _START_ to _END_ of _TOTAL_ entries",
            infoEmpty: "No entries available",
            search: "Search:"
          }
        });
      });
    },

    destroy_personal_profile_form_datatables() {
      if (!$.fn.DataTable) {
        return;
      }

      $('.personal-profile-form-table').each(function () {
        if ($.fn.DataTable.isDataTable(this)) {
          $(this).DataTable().destroy();
        }
      });
    },

    get_personal_profile_user_name(user) {
      return [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim() || user?.email || 'Unknown user';
    },

    get_personal_profile_answer_cell(row, questionId) {
      return row?.answers?.[String(questionId)] || { text: '-', files: [] };
    },

    get_personal_profile_form_tables() {
      const formsMap = new Map();

      (this.personal_profile_forms_users || []).forEach((profileEntry) => {
        (profileEntry.forms || []).forEach((formEntry) => {
          if (!formEntry?.answers?.length || !formEntry?.form?.id) {
            return;
          }

          const formId = String(formEntry.form.id);
          if (!formsMap.has(formId)) {
            formsMap.set(formId, {
              form: formEntry.form,
              questions: [],
              rows: []
            });
          }

          const table = formsMap.get(formId);
          const answerMap = {};

          formEntry.answers.forEach((answer) => {
            const questionId = String(answer?.question?.id || answer?.id);
            const questionLabel = answer?.question?.question || 'Question';

            if (!table.questions.some((question) => String(question.id) === questionId)) {
              table.questions.push({
                id: questionId,
                question: questionLabel
              });
            }

            const fileNames = (answer.files || [])
              .map((fileItem) => fileItem?.file?.name)
              .filter(Boolean);

            let cellText = answer?.answer || '';
            if (fileNames.length) {
              const fileText = `Files: ${fileNames.join(', ')}`;
              cellText = cellText ? `${cellText} | ${fileText}` : fileText;
            }

            answerMap[questionId] = {
              text: cellText || '-',
              files: answer.files || []
            };
          });

          table.rows.push({
            user: profileEntry.user,
            location: profileEntry?.location,
            base_profile_id: profileEntry.base_profile_id,
            answers: answerMap
          });
        });
      });

      return Array.from(formsMap.values());
    },

    export_personal_profile_form_table(formTable) {
      export_personal_profile_form_table_csv(formTable, {
        getUserName: this.get_personal_profile_user_name,
        getLocation: (row) => row?.location || '-',
        getAnswerCell: this.get_personal_profile_answer_cell
      });
    },
    onCommentInput() {
    const words = this.commentText.split(/\s+/);
    const lastWord = words[words.length - 1].trim();

    if (lastWord === "@") {
      this.searchQuery = "";
      this.showSuggestions = this.members.length > 0;
      return;
    }

    if (lastWord.startsWith("@") && lastWord.length > 1) {
      this.searchQuery = lastWord.slice(1);
      this.showSuggestions = this.filteredUsers.length > 0;
    } else {
      this.showSuggestions = false;
      this.searchQuery = "";
    }
  },

  selectUser(user) {
    const words = this.commentText.split(/\s+/);
    words.pop();
    words.push(`@${user.first_name}_${user.last_name}`);
    this.commentText = words.join(" ") + " ";
    this.showSuggestions = false;
    this.searchQuery = "";
  },

    view_profile(report){
          window.location = `/profile?user_id=${report.creater.id}`;

    },
    view_company(report){
        const base = report.creater.base_profile?.id;
        const type = report.creater?.base_profile?.profile_type;

        window.location = `/profile?base=${base}&type=${type}`;

    },
    openForwardModal(report) {
    this.reportToForward = report;
    $('#forwardReportModal').modal('show');
  },

  handle_portal_load(loadedPortals) {

    const currentPortalId = parseInt(this.$route.params.portal_id,10);
    this.portals = loadedPortals;
    const portal = loadedPortals.find(p => parseInt(p.id,10) === currentPortalId);

    this.portals = loadedPortals.filter(p => parseInt(p.id,10) !== currentPortalId);

    if (portal && !portal.is_public) {
        this.portals = this.portals.filter(p => !p.is_public);
    }
},
    closeMenu(reportId) {
      const checkbox = document.getElementById('menu-open-' + reportId);
      if (checkbox) {
        checkbox.checked = false;
      }
    },
    loadMoreReports() {
      this.currentPage++;
    },
    getFileIcon(fileUrl) {
      if (fileUrl.includes('.pdf')) return 'https://cdn-icons-png.flaticon.com/128/337/337946.png';
      if (fileUrl.includes('.doc') || fileUrl.includes('.docx')) return 'https://cdn-icons-png.flaticon.com/128/337/337932.png';  // Word icon
      if (fileUrl.includes('.xls') || fileUrl.includes('.xlsx')) return 'https://cdn-icons-png.flaticon.com/128/337/337958.png';  // Excel icon
      return 'https://cdn-icons-png.flaticon.com/128/337/337940.png';
    },
    getFileName(fileUrl) {
      const decodedUrl = decodeURIComponent(fileUrl);
      const cleanUrl = decodedUrl.split('?')[0];
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    },
    closeFeedMenu(exchange_hubID) {
      const checkbox = document.getElementById('menu-open-' + exchange_hubID);
      if (checkbox) {
        checkbox.checked = false;
      }
    },

    baseUrl(post, type) {
      const baseUrl = `${window.location.origin}${this.$route.path}`;

      // Dynamically build the URL based on the type (either 'hub' or 'report')
      if (type === 'exchange_hub') {
        return `${baseUrl}?hub_id=${post.id}`;
      } else if (type === 'report') {
        return `${baseUrl}?report_id=${post.id}`;
      }
      return baseUrl
    },

    getIdFromURL(param) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    },
    addReportToHome(newReport) {

      if (newReport) {
        newReport.total_comments = newReport.total_comments || 0;
        newReport.like_count = newReport.like_count || 0;
        this.reports.unshift(newReport);
        this.reports.forEach((report) => {
    if (report.report_link) {
      this.fetchReportPreview(report);
    }
    });
      }
      this.temporaryPost = null;
    },
    addTemporaryPost(post) {
      this.temporaryPost = post;
    },
    removeTemporaryPost() {
      this.temporaryPost = null;
    },
    portalProfile(portal){
      this.portal_profile=portal
    },

    addNewPortal(newPortal) {
      if (newPortal) {
        newPortal.has_access="approved"
        this.$refs.portals.portals.unshift(newPortal)
      }
    },

    addNewSegement(newSegment) {
      if (newSegment) {
      this.$refs.topics.topics.unshift(newSegment)
      }
    },
    open_feed_edit_report(report) {
      this.$refs.createFeedRef?.open_edit_report?.(report);
    },
    update_report_in_list(updatedReport) {
      const reportIndex = this.reports.findIndex(
        (report) => String(report.id) === String(updatedReport?.id),
      );
      if (reportIndex !== -1) {
        this.reports.splice(reportIndex, 1, updatedReport);
      }
    },
    clear_reports_filter(){
      this.topic_id = '';
      this.filterReports();
    },
    resetSelection(){
      this.editFileName='';
      this.edit_name='';
      this.edit_description='';
      this.edit_documents = [];
      this.edit_voice_id =null;
      this.editFileName='';
      this.edit_report_name= '',
      this.edit_report_id=null,
      this.edit_report_description='',

      this.upload_media='';
      this.audio_file = null;
      this.audio_file_name = '';
      this.errors={};
      this.comments_off=true;
    },
async submit_comment(report_id) {
  if (!this.token_exists) {
    this.$router.push('/sign_in_finale');
    return;
  }

  const comment_text = $("#comment_text_area").val();

  if (comment_text.trim() === "") {
    Swal.fire({
      icon: 'error',
      title: 'Please write a comment before submitting.',
      timer: 2000,
      showConfirmButton: false,
    });
    return;
  }

  const baseUrl = `${window.location.origin}${this.$route.path}?report_id=${report_id}`;
  this.commentText = "";
  $("#comment_text_area").val("");

  const request_data = {
    report_id,
    comment_text,
    base_url: baseUrl
  };

  const request_url = `${GLOBAL_URL}/portal_management/add_report_comment/`;

  $.ajax({
    url: request_url,
    method: 'POST',
    headers: {
      'Authorization': `Token ${this.getToken()}`,
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(request_data),
    success: (response) => {
  if (response.status === "success") {
    const newComment = response.data.comment_data;

    // ✅ Find the report in parent state
    const reportIndex = this.reports.findIndex(r => r.id === report_id);
    const report = this.reports.at(reportIndex); // safer access

    if (report) {
      // ✅ Replace comments array so Vue notices the change
      report.comments = [newComment].concat(report.comments);

      // ✅ Increment total_comments
      report.total_comments = (report.total_comments || 0) + 1;

      // ✅ Replace parent reports array for top-level reactivity
      this.reports = Array.from(this.reports);
    }

    // Clear input
    this.commentText = "";
    $("#comment_text_area").val("");
  }
},
    error: () => {
      Swal.fire({
        icon: 'error',
        title: 'Could not add comment',
        text: 'Please try again later.',
        timer: 3000,
        showConfirmButton: false,
        position: 'bottom-end',
        toast: true
      });
    },
    complete: () => {
      this.isSubmitting = false;
    }
  });
},
handleAddComment({ report_id, newComment }) {
  const reportIndex = this.reports.findIndex(r => r.id === report_id);
  const report = this.reports.at(reportIndex); // ✅ safe accessor

  if (report) {
    report.comments = [newComment].concat(report.comments);
    this.reports = Array.from(this.reports); // ✅ reactivity trigger
  }
},
    createHub() {
      this.errors = {};

      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we process your request.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      this.isSubmitting = true;

      const formData = new FormData();
      formData.append('name', this.topic);
      formData.append('topic', this.topic_id);
      formData.append('creater', this.user_id);
      formData.append('description', this.description);


      if (this.upload_media_hub) {
        formData.append('document', this.upload_media_hub);
      }

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_exchange_hub_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: () => {
          Swal.close();

          Swal.fire({
            icon: 'success',
            title: 'Voice Created',
            showConfirmButton: false,
            timer: 1000,
            position: 'bottom-end',
            toast: true
          }).then(() => {
            this.resetForm();
            window.location.reload();
          });
        },
        error: () => {
          Swal.close();
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Something went wrong. Please try again.',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },

    handlePortalAccepted() {
      this.$refs.topics.fetchPortalMembers();
    },
    fetchPostsByTopic(topicId) {
      this.handleTopicSelected(topicId);
      // this.fetchReports();
    },

    deleteReport(report_id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'DELETE',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_report_api/`,
            data: { report_id: report_id },
            headers: {
              'Authorization': `Token ${this.getToken()}`,
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                this.reports = this.reports.filter(report => report.id !== report_id);
                Swal.fire({
                  title: 'Deleted!',
                  text: 'The feed has been deleted.',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1000,
                  position: 'bottom-end',
                  toast: true
                })
              }
            },
            error: () => {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to delete the feed. Please try again.',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        }
      });
    },
    setVisibility(isPublic) {
      this.is_public = isPublic;
    },

    resetForm() {
      this.report_name = '';
      this.report_url = '';
      this.topic = '';
      this.description = '';
      this.upload_media = null;
      this.is_public = true;
      this.errors = {};
    },

    getToken() {
      return get_token();
    },
    toggleFeedInput() {
      this.feed_toggle = true;
      this.voice_toggle = false;
    },
    toggleVoiceInput() {
      this.voice_toggle = true;
      this.feed_toggle = false;
    },

    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
    },
    handle_drop(event) {
      this.isDragging = false;
      const files = Array.from(event?.dataTransfer?.files || []);
      this.add_edit_preview_files(files);
    },
    handleFileUpload(event) {
      const files = Array.from(event?.target?.files || []);
      this.add_edit_preview_files(files);
      if (event?.target) {
        event.target.value = "";
      }
    },
    add_edit_preview_files(files = []) {
      files.forEach((file) => {
        this.upload_files.push(file);
        const fileName = file.name || "";
        const fileType = file.type || "";
        let previewType = "file";
        if (fileType.startsWith("image/")) previewType = "image";
        if (fileType.startsWith("video/")) previewType = "video";

        this.previews.push({
          name: fileName,
          type: previewType,
          src: previewType === "file" ? "" : URL.createObjectURL(file),
        });
      });
      this.upload_media = this.upload_files[0] || null;
    },
    remove_preview(index) {
      const [preview] = this.previews.splice(index, 1);
      this.upload_files.splice(index, 1);
      if (preview?.src) {
        URL.revokeObjectURL(preview.src);
      }
      this.upload_media = this.upload_files[0] || null;
    },
    markFileForRemoval(fileId, index) {
      if (fileId && !this.files_to_remove.includes(fileId)) {
        this.files_to_remove.push(fileId);
      }
      this.edit_documents?.report_files?.splice(index, 1);
    },

    logout_user() {
      Swal.fire({
        title: 'Are you sure?',
        text: "Are you sure you want to logout?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, log out!',
        position: 'bottom-end',
        toast: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          clear_token();
          window.location.reload();
        }
      });
    },
    fetch_topics() {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_topics_api`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: { portal_id: this.$route.params.portal_id },
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.topics = response.topics
            Swal.close()
          }

        },

        complete: () => {
          this.isLoading = false;
          Swal.close()
        }
      });
    },
    forwardReport(report, portal_id) {
      Swal.fire({
        title: 'Forwarding Report...',
        text: 'Please wait while we forward the report.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const formData = new FormData();
      formData.append('original_report_id', report.id);
      formData.append('destination_portal_id', portal_id);

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_forwarded_report_api/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
        },
        data: formData,
        processData: false,
        contentType: false,
        success: (response) => {
          if (response.status === 'success') {
            Swal.fire({
              title: 'Success',
              text: 'Report forwarded successfully.',
              icon: 'success',
              timer: 1500,
              showConfirmButton: false,
              position: 'bottom-end',
              toast: true
            });

            $('#forwardReportModal').modal('hide');
          }
        },
        error: (error) => {
          console.error('Forward error:', error);
          Swal.fire({
            title: 'Error',
            text: 'Failed to forward report.',
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },
    filter_events() {
      this.token_exists = get_token();

      const portal_id = this.$route.params.portal_id
      const payload = {
        filter_values: {
          portal_id: portal_id

        }
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/filter_events_api/`,
        method: "POST",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        data: JSON.stringify(payload),
        success: (data) => {
          this.events = data.data.events

          ;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    openEditBoardModal(board){
      this.editingBoard = board;
      this.board_name = board.name;
      this.isEditing= true;
    },
    validationBoardForm() {
      this.errors = {};
      let valid = true;

      if (!this.board_name) {
        this.errors.board_name = 'Board name is required';
        valid = false;
      }

      if (!this.selectedPortalId) {
        this.errors.portal = "You must tag a portal.";
      }
      return valid;
    },
    updateBoard() {
      if (!this.validationBoardForm()) {
        return;
        }
    this.isSubmitting = true;

    const requestData = {
      board_id: this.editingBoard.id,
      name: this.board_name,
      portal_id: this.$route.params.portal_id,
    };

    $.ajax({
      type: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_board/`,
      contentType: "application/json",
      headers: {
        'Authorization': `Token ${this.getToken()}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(requestData),
      success: (response) => {
        if (response.status === "success") {
          this.fetch_portal_boards();
          $('#edit_board_modal').modal('hide');
          this.$emit('editBord', response.board);
          this.resetForm();
        }
      },
      error: (response) => {
        const response_data = response.responseJSON;
        if (response_data.status == "error") {
          this.errors.board_name = response_data.message;
        }
      },

      complete: () => {
        this.isSubmitting = false;
      }
    });},
     deleteBoard(board_id) {
        Swal.fire({
          title: 'Are you sure?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          position: 'bottom-end',
          toast: true
        }).then((result) => {
          if (result.isConfirmed) {
            $.ajax({
              type: 'DELETE',
              url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_board/`,
              data: { board_id: board_id },
              headers: {
                'Authorization': `Token ${this.getToken()}`,
              },
              success: (response) => {
                const status = response.status;
                if (status === "success") {
                  this.boards = this.boards.filter(board => board.id !== board_id);
                }
              },
              error: () => {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Failed to delete the feed. Please try again.',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }
            });
          }
        });
      },
    // fecthPortalData() {
    //   $.ajax({
    //     url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_by_id/`,
    //     method: 'GET',
    //     headers: {
    //       'Authorization': `Token ${this.getToken()}`,
    //       'Content-Type': 'application/json'
    //     },
    //     data: { portal_id: this.$route.params.portal_id },
    //     success: (response) => {
    //       this.portal_profile = response.message

    //     },
    //   });
    // },
    // fetchReports() {
    //   alert("It comes here")

    //   const topicId = this.topic_id;

    //   if(!topicId){
    //     this.isLoading = false;
    //     return;
    //   }
    //   const payload = {
    //     filter_values: {
    //       topic: topicId,
    //       portal_id: this.$route.params.portal_id
    //     }
    //   }
    //   $.ajax({
    //     url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_reports_api/`,
    //     method: 'POST',
    //     headers: {
    //       'Authorization': `Token ${this.getToken()}`,
    //       'Content-Type': 'application/json'
    //     },
    //     data : JSON.stringify(payload),
    //     success: (data) => {
    //       var status =data.status
    //       if(status === "success"){
    //         this.reports = data.data.report_data
    //       }
    //     },
    //     complete: () => {
    //       this.isLoading = false;
    //     }
    //   });
    // },
    handleTopicSelected(topicId) {
      const id = Number(topicId);
      if (!Number.isInteger(id) || id <= 0) {
        this.topic_id = '';
        this.filterReports();
        return;
      }
      this.topic_id = id;
      this.currentPage = 1;
      this.fetchReportsByTopic(id);
    },

    async fetchReportsByTopic(topicId) {
      this.is_report_loading = true;
      try {
        const payload = { topic_id: topicId, portal_id: this.$route.params.portal_id };
        const res = await fetch(
          `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_reports_by_topic/`,
          {
            method: 'POST',
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          }
        );

        const data = await res.json();
        if (data?.status === 'success') {
          this.reports = data.reports || data.report_data || [];
        } else {
          this.reports = [];
          Swal.fire({
            title: 'Error',
            text: data?.message || 'Failed to fetch reports',
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      } finally {
        this.is_report_loading = false;
        this.hasLoadedOnce = true;
      }
    },

processPortalReports(results) {
  results.forEach((report) => {
    if (report.report_link) {
      this.fetchReportPreview(report);
    }
  });

  // Prevent duplicates if needed
  const newReports = results.filter(r => !this.reports.some(existing => existing.id === r.id));
  this.reports.push(...newReports);
},

async filterReports() {
  if (this.is_report_loading) return;

  this.is_report_loading = true;
  const portal_id = this.$route.params.portal_id;

  if (this.activePortalId !== portal_id) {
    this.reports = [];
    this.page = 1;
    this.hasMore = false;
    this.preloadedReports = [];
    this.activePortalId = portal_id;
  }
  const report_id = this.$route.query.report_id;

  const headersConfig = {
    headers: {
      Authorization: `Token ${this.getToken()}`,
      'Content-Type': 'application/json',
    },
  };
  try {
    let results;

    // 1️⃣ Use preloaded reports if available
    if (this.preloadedReports.length) {
      results = this.preloadedReports;
      this.preloadedReports = [];
      this.page += 1;
    } else {
      // 2️⃣ Normal fetch
      const res = await axios.post(
        `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_reports_by_portal/`,
        { portal_id, page: this.page, page_size: this.page_size },
        headersConfig
      );

      if (res.data.status === 'success' && res.data.report_data) {
        results = res.data.report_data.results || [];
        this.hasMore = res.data.report_data.has_more;
        this.page = res.data.report_data.page + 1;
      }
      else {
        results = [];
        this.hasMore = false;
      }
    }

    // 3️⃣ Process the results
    if (results.length) this.processPortalReports(results);

    // 4️⃣ Preload next page in background
    if (this.hasMore) this.preloadPortalReports(portal_id);

    // 5️⃣ Open modal if report_id is passed
    if (report_id) {
      const selectedReport = this.reports.find(r => r.id == report_id);
      if (selectedReport) {
        this.display_comment_modal(selectedReport);
      }
    }

  } catch (error) {
    console.error('Error fetching reports:', error.response?.data || error.message);
  } finally {
    this.is_report_loading = false;
    this.hasLoadedOnce = true;
  }
},

async preloadPortalReports(portal_id) {
  const headersConfig = {
    headers: {
      Authorization: `Token ${this.getToken()}`,
      'Content-Type': 'application/json',
    },
  };
  try {
    const res = await axios.post(
      `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_reports_by_portal/`,
      { portal_id, page: this.page, page_size: this.page_size },
      headersConfig
    );

    if (res.data.status === 'success' && res.data.report_data) {
      this.preloadedReports = res.data.report_data.results || [];
      this.hasMore = res.data.report_data.has_more;
    }
  } catch (error) {
    console.error('Error preloading reports:', error.response?.data || error.message);
    this.preloadedReports = [];
  }
},



submit_form() {
  this.errors = {};
  if (!(this.validateForm())) {
    return;
  }

  Swal.fire({
    title: 'Submitting...',
    text: 'Please wait while we process your request.',
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });

  this.isSubmitting = true;

  const formData = new FormData();
  formData.append('report_name', this.report_name);
  if (this.report_url) {
    formData.append('report_link', this.report_url);
  }
  formData.append('topic_id', this.topic_id);
  formData.append('description', this.description);
  formData.append('is_public', this.is_public);
  if (this.upload_media) {
    formData.append('file', this.upload_media);
  }

  $.ajax({
    type: "POST",
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_report_api/`,
    data: formData,
    processData: false,
    contentType: false,
    headers: {
      'Authorization': `Token ${this.getToken()}`,
    },
    success: (response) => {
      Swal.close();
      const status = response.status;

      if (status === "success") {
        Swal.fire({
          icon: 'success',
          title: 'Feed Created',
          showConfirmButton: false,
          timer: 2000,
          position: 'bottom-end',
          toast: true
        }).then(() => {
          window.location.reload();
        });
        $('#create_report').hide();
      }
    },
    error: () => {
      Swal.close();
      this.isLoading = false;
    },
    complete: () => {
      this.isSubmitting = false;
    }
  })
},
async validateForm() {
  this.errors = {};
  let isValid = true;

  if (this.isReportNameExists(this.report_name)) {
    this.errors.report_name = 'Feed name already exists.';
    isValid = false;
  }

  if (this.report_url && this.report_url.trim()) {
    try {
      new URL(this.report_url);
    } catch (_) {
      this.errors.report_url = 'Please enter a valid URL.';
      isValid = false;
    }
  }

  return isValid;
},
isReportNameExists(name) {
  return this.reports.some(report => report.name.toLowerCase() === name.toLowerCase());
},
display_comment_modal(data) {
  this.report_data = data;
  this.comment_modal_visible = true;
},
open_preview(document) {
    open_file_preview(this, document);
},

 on_content_loaded() {
    this.loading_preview = false;
  },

open_agent(data){
  this.sprint_data=data,
  this.$refs.sprintAgentModal.openOffcanvas();
},

hide_comment_comment() {
  this.report_data = {};
  this.comment_modal_visible = false;
},

setupTextareaAutoResize() {
  const reportTextarea = this.$refs.reportTextarea;
  if (reportTextarea) {
    this.autoResizeTextarea(reportTextarea);
    reportTextarea.addEventListener('input', () => this.autoResizeTextarea(reportTextarea));
  }
},
autoResizeTextarea(textarea) {
  if (textarea) {
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }
},
hasSupportedFile(files) {
  if (Array.isArray(files)) {
    return files.some(fileObj => {
      const file = fileObj.file || {};
      const url = this.get_report_file_url(fileObj);
      const supportedExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.xlsm', '.xlsb'];

    return supportedExtensions.some(ext => url.toLowerCase().indexOf(ext) !== -1);
    });
  }
  return false;
},
get_report_file_url(fileObj) {
  return String(fileObj?.file?.file_url || fileObj?.file?.url || fileObj?.file_url || fileObj?.url || "");
},
    handleSubmit() {
      if (this.validateTopicForm()) {
        this.isSubmitting = true;

        const requestData = {
          topic_name: this.topic_name,
          portal_id: this.$route.params.portal_id
        };
        $.ajax({
          type: "POST",
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_topic_api/`,
          contentType: "application/json",
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(requestData),

          success: (response) => {
            const status = response.status;
            if (status === "success") {
              Swal.fire({
                icon: 'success',
                title: 'Segment Created Successfully',
                text: 'Your Segment has been created.',
                showConfirmButton: false,
                timer: 1000,
                position: 'bottom-end',
                toast: true
              }).then(() => {
                window.location.reload();
                $('#create_topic').modal('hide');
              });
            } else if (status === "error") {
              Swal.fire({
                icon: 'error',
                title: 'Creation Failed',
                text: response.message || 'An error occurred. Please try again.',
                confirmButtonText: 'Retry',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Unexpected Response',
                text: 'The server returned an unexpected response.',
                confirmButtonText: 'Okay',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          },
          error: (response) => {
            const response_data = response.responseJSON;
            if (response_data.status == "error") {
              this.errors.topic_name = response_data.message
            }
          },
          complete: () => {
            this.isSubmitting = false;
          }
        });
      }
    },

    validateTopicForm() {
      this.errors = {};
      let isValid = true;
      if (!this.topic_name.trim()) {
        this.errors.topic_name = 'Segment name is required.';
        isValid = false;
      }
      return isValid;
    },


    truncateDescription(description, maxLength = 25) {
      const words = description.split(/\s+/);
      if (words.length > maxLength) {
        return words.slice(0, maxLength).join(" ") + '...';
      }
      return description;
    },

    getDisplayedReportDescription(report) {
      const description = report.description;

      if (this.isReportExpanded(report.id)) {
        return description;
      }

      return this.truncateDescription(description);
    },

    toggleReportReadMore(reportId) {
      const index = this.expandedReports.indexOf(reportId);
      if (index === -1) {
        this.expandedReports.push(reportId);
      } else {
        this.expandedReports.splice(index, 1);
      }
    },

    isReportExpanded(reportId) {
      return this.expandedReports.includes(reportId);
    },

    open_likes_modal(like_users) {
      this.modal_likes = like_users;
    },
likeReport(report) {
  if (!this.token_exists) {
    this.$router.push('/sign_in_finale');
    return;
  }
  const reportId = report.id;

  $.ajax({
    type: "POST",
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_like/`,
    contentType: "application/json",
    headers: {
      'Authorization': `Token ${this.getToken()}`,
    },
    data: JSON.stringify({ report_id: reportId }),
    success: (response) => {
      if (response.status === "success") {
        const liked_report = this.reports.find(r => r.id === reportId);
        if (liked_report) {
          // ✅ increment both internal and displayed like count
          liked_report.like_count++;
          liked_report.total_likes = (liked_report.total_likes || 0) + 1;

          const currentUser = {
            user: {
              id: this.user_details.user_id,
              first_name: this.user_details.first_name,
              last_name: this.user_details.last_name,
              profile_picture: this.user_details.profile_picture || null,
              is_blocked: false
            }
          };

          // Prevent duplicates
          const alreadyLiked = liked_report.likes.some(
            (u) => u.user && u.user.id === this.user_details.user_id
          );

          if (!alreadyLiked) {
            liked_report.likes.push(currentUser);
          }
          // ✅ Replace reports array for reactivity (if needed)
          this.reports = [...this.reports];
        }

        if (
          (typeof reportId === 'number' && Number.isInteger(reportId)) ||
          (typeof reportId === 'string' && /^[a-zA-Z0-9_-]+$/.test(reportId))
        ) {
          Reflect.set(this.likedReports, reportId, true);
          localStorage.setItem("likedReports", JSON.stringify(this.likedReports));
        } else {
          console.warn('Invalid reportId:', reportId);
        }
      }
    }
  });
},
unlikeReport(report) {
  if (!this.token_exists) {
    this.$router.push('/sign_in_finale');
    return;
  }

  const reportId = report.id;

  $.ajax({
    type: "POST",
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_like/`,
    contentType: "application/json",
    headers: {
      'Authorization': `Token ${this.getToken()}`,
    },
    data: JSON.stringify({ report_id: reportId }),
    success: (response) => {
      if (response.status === "success") {
        const unliked_report = this.reports.find(r => r.id === reportId);
        if (unliked_report) {
          if (unliked_report.like_count > 0) {
            unliked_report.like_count--;   // update like count shown on each report
          }
          if (unliked_report.total_likes > 0) {
            unliked_report.total_likes--; // update global total likes
          }

          try {
            const currentUserId = String(this.user_details.user_id);
            if (Array.isArray(unliked_report.likes)) {
              const idx = unliked_report.likes.findIndex(u => u && u.user && String(u.user.id) === currentUserId);
              if (idx !== -1) {
                unliked_report.likes.splice(idx, 1);
              }
            }
            // Ensure modal list is synced if it was opened
            if (Array.isArray(this.modal_likes) && this.modal_likes.length) {
              this.modal_likes = this.modal_likes.filter(u => !(u && u.user && String(u.user.id) === currentUserId));
            }
          } catch (err) {
            console.warn('Error removing user from likes:', err);
          }

          // Reassign reports to trigger reactivity
          this.reports = [...this.reports];
        }

        // Validate reportId before setting
        if (
          (typeof reportId === 'number' && Number.isInteger(reportId)) ||
          (typeof reportId === 'string' && /^[a-zA-Z0-9_-]+$/.test(reportId))
        ) {
          Reflect.set(this.likedReports, reportId, false);
          localStorage.setItem("likedReports", JSON.stringify(this.likedReports));
        } else {
          console.warn('Invalid reportId:', reportId);
        }
      }
    }
  });
},
    likeExchangeHub(exchangeHub) {
      const exchangeHubId = exchangeHub.id;

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_exchange_hub_like/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: JSON.stringify({ exchangehub_id: exchangeHubId }),
        success: (response) => {
          if (response.status === "success") {

            exchangeHub.like_count++;
            const reactButton = document.getElementById(`react-button${exchangeHubId}`);
            const reactedButton = document.getElementById(`reacted-button${exchangeHubId}`);

            if (reactButton) {
              reactButton.classList.add('d-none');
            }

            if (reactedButton) {
              reactedButton.classList.remove('d-none');
            }
          }
        }
      });
    },
    unlikeExchangeHub(exchangeHub) {
      const exchangeHubId = exchangeHub.id;

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_exchange_hub_like/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: JSON.stringify({ exchangehub_id: exchangeHubId }),
        success: (response) => {
          if (response.status === "success") {
            exchangeHub.like_count--;
            const reactButton = document.getElementById(`react-button${exchangeHubId}`);
            const reactedButton = document.getElementById(`reacted-button${exchangeHubId}`);

            if (reactButton) {
              reactButton.classList.remove('d-none');
            }

            if (reactedButton) {
              reactedButton.classList.add('d-none');
            }
          }
        }
      });
    },
    getExchangeHubLikes(exchangeHub) {
      if (!exchangeHub || !exchangeHub.id) {
        return;
      }

      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/retrieve_exchange_hub_likes/`,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: { exchangehub_id: exchangeHub.id },
        success: (response) => {
          if (response.status === "success") {
            const likes = response.exchange_hub_likes;
            exchangeHub.like_count = likes.length;

            const userId = this.get_user_id();
            const isLiked = likes.some(like => like.user.id === parseInt(userId, 10));

            const reactButton = document.getElementById(`react-button${exchangeHub.id}`);
            const reactedButton = document.getElementById(`reacted-button${exchangeHub.id}`);

            if (reactButton) {
              reactButton.classList.toggle('d-none', isLiked);
            }

            if (reactedButton) {
              reactedButton.classList.toggle('d-none', !isLiked);
            }
          }
        },
      });
    },
    toggleReadMore(reportId) {
      const index = this.expandedReports.indexOf(reportId);
      if (index === -1) {
        this.expandedReports.push(reportId);
      } else {
        this.expandedReports.splice(index, 1);
      }
    },
  
    togglePinReport(report) {
      const newPinStatus = !report.is_pinned;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/pin_report_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          post_id: report.id,
          is_pinned: newPinStatus
        }),
        success: (response) => {
          if (response.status === 'success') {
            report.is_pinned = newPinStatus;

            const index = this.reports.indexOf(report);
            if (index > -1) {
              this.reports.splice(index, 1);
            }
            if (newPinStatus) {
              this.reports.unshift(report);
            }
          }
        },
      });
    },

    handleAudioUpload(event) {
          const file = event.target.files[0];
          if (file) {
            if (!file.type.startsWith('audio/')) {
              this.audioError = 'Only audio files are allowed.';
              this.audio_file = null;
              this.audio_file_name = '';
              event.target.value = '';
            } else {
              this.audio_file_name = file.name;
              this.audioError = '';
              this.audio_file = file;
            }
          } else {
            this.audio_file_name = '';
            this.audioError = '';
            this.audio_file = null;
          }
        },

        handleHomeFilterFileUpload(event) {
          const file = event.target.files[0];
          if (file) {
            if (file.type.startsWith('audio/')) {
              this.fileError = 'Audio files are not allowed.';
              this.upload_media = null;
              this.editFileName = '';
              event.target.value = '';
            } else {
              this.editFileName = file.name;
              this.fileError = '';
              this.upload_media = file;
            }
          } else {
            this.editFileName = '';
            this.fileError = '';
            this.upload_media = null;
          }
        },

        startRecording() {
                navigator.mediaDevices.getUserMedia({ audio: true })
                  .then((stream) => {
                    this.recordedChunks = [];
                    this.mediaRecorder = new MediaRecorder(stream);

                    this.mediaRecorder.ondataavailable = (event) => {
                      if (event.data.size > 0) {
                        this.recordedChunks.push(event.data);
                      }
                    };

                    this.mediaRecorder.onstop = () => {
                      const audioBlob = new Blob(this.recordedChunks, { type: 'audio/wav' });
                      this.audio_file = audioBlob;
                      this.audio_file_name = 'recording.wav';
                    };

                    this.mediaRecorder.start();
                    this.isRecording = true;
                    this.recordingTime = 0;
                    clearInterval(this.recordingTimer);
                    this.recordingTimer = setInterval(() => {
                      this.recordingTime += 1;
                    }, 1000);
                  })
                  .catch((error) => {
                    if (error.name === 'NotAllowedError') {
                      Swal.fire({
                        icon: 'error',
                        title: 'Microphone Access Denied',
                        text: 'Please allow microphone access in your browser settings and refresh the page.',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                      });
                    } else {
                      Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: `Error accessing microphone: ${error.message}`,
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                      });
                    }
                  });
              },

              stopRecording() {
                if (this.mediaRecorder && this.isRecording) {
                  this.mediaRecorder.stop();
                  this.isRecording = false;
                  clearInterval(this.recordingTimer);
                }
              },

    copyReportLinkToClipboard(report) {
      const link = this.baseUrl(report, 'report');
      navigator.clipboard.writeText(link).then(() => {
        this.showToast('Link copied to clipboard!');
      })
    },
    showToast(message) {
    document.querySelector('#copyToast .toast-body').textContent = message;

    $('#copyToast').fadeIn(300).addClass('show');
    setTimeout(function() {
      $('#copyToast').fadeOut(300).removeClass('show');
    }, 3000);
  },
  copyVoiceLinkToClipboard(exchange_hub) {
    const link = this.baseUrl(exchange_hub, 'exchange_hub');
      navigator.clipboard.writeText(link).then(() => {
        this.showTheToast('Link copied to clipboard!');
      })
    },
    showTheToast(message) {
    document.querySelector('#copyTheToast .toast-body').textContent = message;

    $('#copyTheToast').fadeIn(300).addClass('show');
    setTimeout(function() {
      $('#copyTheToast').fadeOut(300).removeClass('show');
    }, 3000);
  },
  fetch_Portal_admin() {
    const portal_id = this.$route.params.portal_id;
    const user_id = Number(this.get_user_id());

    const payload = {
        portal_id: portal_id,
        user_id: user_id
    };

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_plartform_admin_api/`,
      method: 'POST',
      headers: {
        'Authorization': `Token ${this.getToken()}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(payload),
      success: (response) => {
        if (response.status === "success" )  {
          const admins = response?.portal_admin_detalails || [];// ✅ Check if logged-in user_id is inside the returned admins
          const isAdmin = admins.some((admin) => Number(admin?.user?.id) === user_id);
          this.portal_admin = isAdmin;
        } else {
          this.portal_admin = false;
        }
      },
      error: () => {

        this.portal_admin=false

      },
      complete: () => {
        this.isLoading = false;
      }
    });
  },
  fetch_document_approval_request() {

    if (!this.portal_id) return;
    const payload = {
      filter_values: {
        portal_id: this.portal_id

      }
    }

    this.isLoading = true;
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_document_approval/`,
      method: 'POST',
      data: JSON.stringify(payload),
      headers: {
        'Authorization': `Token ${this.getToken()}`,
        'Content-Type': 'application/json'
      },
      success: (response) => {
        this.document_approvals = response.data.document_approvals;

        setTimeout(() => {

          this.loading = false;
        }, 1000);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  },

  handleBoardClick(board) {
    this.$router.push({
      name: 'view_board',
      params: {
        portal_id: this.$route.params.portal_id,
        board_id: board.id,
        board_name: board.name
      }
    });
  },

  handle_sub_portals(sub_portals) {
    this.fetch_sub_reports(sub_portals.id);

  },
  fetch_sub_reports(sub_portal_id) {
    this.isLoading = true;
    const payload = {
      filter_values: {
        sub_portal: sub_portal_id

      }
    }
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_reports_api/`,
      method: 'POST',
      headers: {
        'Authorization': `Token ${this.getToken()}`,
        'Content-Type': 'application/json'
      },
      data : JSON.stringify(payload),
      success: (data) => {
        var status =data.status
        if(status === "success"){
          this.reports = data.data.report_data

          const reportId = this.getIdFromURL('report_id');
          if (reportId) {
            const report = this.reports.find(report => report.id === parseInt(reportId,10));
            if (report) {
              this.display_comment_modal(report);
            }
          }
          this.reports.forEach(report => {
            if (report && report.id) {
              if (report.report_files && Array.isArray(report.report_files) && report.report_files.length > 0) {
                const firstFile = report.report_files[0].file;

                this.pdf_file_url = firstFile?.file_url || '';
                this.pdf_file = firstFile || {};
                this.file_name = firstFile?.name || '';
              } else {

                this.pdf_file = [];
                this.pdf_file_url = '';
                this.file_name = '';
              }
            }
          });
        }
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  },
  fetch_portal_boards() {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_boards/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({ portal_id: this.$route.params.portal_id }),
        success: (response) => {
          var status = response.status
          if(status === "success") {
            this.$nextTick(() => {
              this.current_portal_permissions = response.portal_permissions;
              this.boards=  response.data;
              this.isLoading = false;
            });
          }

        },

        complete: () => {
          this.isLoading = false;
          Swal.close()
        }
      });
    },
     getInitials(name) {
        const words = name.trim().split(" ");
        return words.length === 1
          ? words[0].substring(0, 2).toUpperCase()
          : (words[0][0] + words[1][0]).toUpperCase();
      },
  create_portal_board() {
    let base_url = '/view_board'
    const portal_id = this.$route.params.portal_id;
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_board/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({ portal_id: portal_id,name: this.board_name, base_url: base_url }),
          success: (response) => {
            var status = response.status
            if (status == "success") {
              const board_id = response.data.id
              const board_name = response.data.name
              this.$router.push(`/view_board/${portal_id}/${board_id}/${board_name}`)
            }

          },

          complete: () => {
            this.isLoading = false;
            Swal.close()
          }
        });
      },
      fetch_portal_members(callback) {
              this.loading_members = true;
              $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
                method: "GET",
                data: { portal_id: this.$route.params.portal_id },
                headers: {
                  "Authorization": `Token ${this.getToken()}`,
                  "Content-Type": "application/json"
                },
                success: (response) => {

                  if (response.status === "success") {
                    this.members = response.data.members;
                  }
                  if (callback) callback();
                },
                error: (xhr) => {
                  if (xhr.status === 403) {
                    this.$router.push("/");
                    Swal.fire({
                      icon: "error",
                      title: "Access Denied",
                      text: "You are not authorized to be in this portal.",
                      showConfirmButton: false,
                      timer: 3000,
                      position: 'bottom-end',
                      toast: true
                    });
                  }
                },
                complete: () => {
                  this.loading_members = false;
                }
              });
            },

      get_permissions_types() {
            this.token_exists = get_token();

            $.ajax({
              url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_permissions/`,
              method: "GET",
              headers: this.token_exists
                ? {
                  Authorization: `Token ${this.getToken()}`,
                  "Content-Type": "application/json",
                }
                : {},
              success: (response) => {
                this.permission_types = response.permission_types;

                this.permission_types.forEach(perm => {
                  this.permission_map[perm.name.toLowerCase()] = perm.id;
                });
              },
              complete: () => {
                this.isLoading = false;
              },
            });

          },

          updateUserPermission(user_permissions, permission_name) {
            switch (permission_name) {
              case 'create':
                user_permissions.create = true;
                break;
              case 'edit':
                user_permissions.edit = true;
                break;
              case 'download':
                user_permissions.download = true;
                break;
              case 'delete':
                user_permissions.delete = true;
                break;
              case 'upload':
                user_permissions.upload = true;
                break;
              default:
                // no action for unknown permissions
                break;
            }
          },

          handle_permission_change(user, permission) {
            const permObj = this.permission_types.find(p => p && p.name && p.name.toLowerCase() === permission.toLowerCase());
            const permission_type_id = permObj ? permObj.id : null;

            const getPermissionValue = (perm) => {
              switch (perm) {
                case 'create':
                  return user.create;
                case 'edit':
                  return user.edit;
                case 'upload':
                  return user.upload;
                case 'download':
                  return user.download;
                case 'delete':
                  return user.delete;
                default:
                  return undefined;
              }
            };

            const setPermissionValue = (perm, val) => {
              switch (perm) {
                case 'create':
                  user.create = val; break;
                case 'edit':
                  user.edit = val; break;
                case 'upload':
                  user.upload = val; break;
                case 'download':
                  user.download = val; break;
                case 'delete':
                  user.delete = val; break;
                default:
                  break;
              }
            };

            const currentValue = getPermissionValue(permission);

            if (!permission_type_id) {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `Permission type not found: ${permission}` ,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
              setPermissionValue(permission, !currentValue);
              return;
            }
            if (currentValue === false) {
              this.unassign_portal_permissions(
                [user.portal_access?.id],
                [permission_type_id]
              );
              return;
            }
            const payload = {
              portal_id: this.$route.params.portal_id,
              portal_member_ids: [user.portal_access?.id],
              permission_type_ids: [permission_type_id]
            };

            $.ajax({
              url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/set_portal_permissions/`,
              method: 'POST',
              headers: {
                Authorization: `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
              },
              data: JSON.stringify(payload),
              success: () => {
                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text:'Portal permissions assigned successfully.',
                  showConfirmButton: false,
                  timer: 1500,
                  position: 'bottom-end',
                  toast: true
                });
                this.get_portal_permissions()
              },
              error: () => {
                setPermissionValue(permission, !currentValue);
              }
            });
          },

    scrollTabs(direction) {
      const el = this.$refs.tabsContainer
      if (!el) return

      el.scrollBy({
        left: direction === 'right' ? 160 : -160,
        behavior: 'smooth'
      })
    },

    open_portal_members_tab() {
      this.activeTab = 'members';
      this.$nextTick(() => {
        const membersTab = document.getElementById('tab-portal-members');
        if (membersTab) {
          membersTab.click();
          membersTab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    },

    open_portal_permissions_tab() {
      this.activeTab = 'permissions';
      this.loading_members = true;

      this.$nextTick(() => {
        const permissionsTab = document.getElementById('tab-portal-permissions');
        if (permissionsTab) {
          permissionsTab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });

      this.fetch_portal_members(() => {
        this.get_portal_permissions();
        this.loading_members = false;
      });
    },

    get_portal_permissions() {
      this.token_exists = get_token();
      const portal_id = this.$route.params.portal_id
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_permissions/?portal_id=${portal_id}`,
        method: "GET",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        success: (response) => {
          const raw_permissions = response.portal_permissions;

          // Find current user's permissions
          const current_user_id = parseInt(this.get_user_id(), 10);
          const currentUserPerms = raw_permissions.find(p => parseInt(p.portal_access?.user?.id, 10) === current_user_id);

          if (currentUserPerms) {
            const perms = currentUserPerms.permissions || [];
            this.current_portal_permissions = {
              create: perms.includes('create'),
              edit: perms.includes('edit'),
              upload: perms.includes('upload'),
              download: perms.includes('download'),
              delete: perms.includes('delete')
            };
          }

          // Map the permissions array for all users
          this.portal_permissions = raw_permissions.map(user => {
            const perms = user.permissions || [];
            return {
              ...user,
              create: perms.includes('create'),
              edit: perms.includes('edit'),
              upload: perms.includes('upload'),
              download: perms.includes('download'),
              delete: perms.includes('delete')
            };
          });
          this.filtered_portal_permissions = this.portal_permissions;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    manage_portal_permissions() {
  // 1. Show the modal immediately
  $('#manage_portal_permissions_modal').modal('show');

  // 2. Set a loading state (optional but recommended)
  this.loading_members = true;

  // 3. Fetch data in the background
  this.fetch_portal_members(() => {
    this.get_portal_permissions();
    this.loading_members = false;
  });
},

    save_portal_permissions() {
      this.portal_permissions.forEach(user => {

        const permission_type_ids = [];

        if (user.create) permission_type_ids.push(this.permission_map.create);
        if (user.edit) permission_type_ids.push(this.permission_map.edit);
        if (user.upload) permission_type_ids.push(this.permission_map.upload);
        if (user.download) permission_type_ids.push(this.permission_map.download);
        if (user.delete) permission_type_ids.push(this.permission_map.delete);

        // 🚫 Skip if no permissions selected or any undefined permission ID
        if (permission_type_ids.length === 0 || permission_type_ids.includes(undefined)) return;

        const payload = {
          portal_id: this.$route.params.portal_id,
          portal_member_ids: [user.portal_access?.id],
          permission_type_ids: permission_type_ids,
        };

        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/set_portal_permissions/`,
          method: "POST",
          headers: {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify(payload),
          success: () => {
            Swal.fire({
              title: "Success",
              text: "Permissions Set Successfully",
              icon: "success",
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
            $('#manage_portal_permissions_modal').modal('hide');
          },
          error: (xhr) => {
            console.error(`Failed to save for ${user.portal_access.user.email}`, xhr.responseJSON);
          }
        });
      });
    },

    unassign_portal_permissions(memberIds, permissionIds) {
      if (!memberIds?.length || !permissionIds?.length) {
        Swal.fire({
          icon: 'warning',
          title: 'Warning',
          text: 'Please select both members and permissions to unassign.',
          showConfirmButton: true
        });
        return;
      }

      Swal.fire({
        title: 'Are you sure?',
        text: 'This will unassign the selected permissions from the selected members.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, unassign permissions',
        cancelButtonText: 'Cancel',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            portal_id: this.$route.params.portal_id,
            portal_member_ids: memberIds,
            permission_type_ids: permissionIds
          };

          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/unassign_portal_permissions/`,
            method: "DELETE",
            headers: {
              Authorization: `Token ${this.getToken()}`,
              "Content-Type": "application/json",
            },
            data: JSON.stringify(payload),
            success: (response) => {
              if (response.status === "success") {
                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: response.message || 'Portal permissions unassigned successfully.',
                  showConfirmButton: false,
                  timer: 1500,
                  position: 'bottom-end',
                  toast: true
                });

                // Refresh permissions after successful unassignment
                this.get_portal_permissions();
              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: response.message || 'Failed to unassign permissions.',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }
            },
            error: (xhr) => {
              console.error('Failed to unassign permissions', xhr.responseJSON);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: xhr.responseJSON?.message || 'Failed to unassign permissions.',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        }
      });
    },
    isExpanded(reportId) {
    return this.expandedReports.includes(reportId);
  },
  toggleDescription(reportId) {
    if (this.isExpanded(reportId)) {
      this.expandedReports = this.expandedReports.filter(id => id !== reportId);
    } else {
      this.expandedReports.push(reportId);
    }
  },
  displayedDescription(report) {
    if (!report.description) return '';

    // Show full description if expanded or shorter than maxLength
    if (this.isExpanded(report.id) || report.description.length <= this.maxLength) {
      return report.description;
    }

    // Truncate and add ellipsis
    return report.description.slice(0, this.maxLength) + '...';
  },
  
searchUsers() {
  const query = this.searchQuery.toLowerCase().trim();

  this.portal_permissions = this.filtered_portal_permissions
    .filter(u => u.portal_access?.user)
    .filter(user => {
      if (!query) return true;

      const first = user.portal_access?.user.first_name || "";
      const last  = user.portal_access?.user.last_name || "";
      const email = user.portal_access?.user.email || "";

      return (
        first.toLowerCase().includes(query) ||
        last.toLowerCase().includes(query) ||
        email.toLowerCase().includes(query)
      );
    });
},
 getCarouselImages(report){
      return report.report_files.filter((item) =>
        item.file.url.includes('.jpg') ||
        item.file.url.includes('.JPG') ||
        item.file.url.includes('.png') ||
        item.file.url.includes('.PNG') ||
        item.file.url.includes('.avif') ||
        item.file.url.includes('.AVIF') ||
        item.file.url.includes('.jpeg') ||
        item.file.url.includes('.JPEG') ||
        item.file.url.includes('.webp') ||
        item.file.url.includes('.WEBP')
      )
    }
},
};

